import { cn } from '@/lib/utils';

export type UrgencyDotProps<UrgencyT extends string> = {
  urgency: UrgencyT;
  className?: string;
};

export function UrgencyDot<UrgencyT extends string>({
  urgency,
  className,
}: UrgencyDotProps<UrgencyT>) {
  const colorClass = (() => {
    switch (urgency) {
      case 'Routine' as UrgencyT:
        return 'bg-amber-500';
      case 'Urgent' as UrgencyT:
        return 'bg-red-600';
      default:
        return 'bg-muted-foreground/40';
    }
  })();

  return (
    <span
      className={cn('h-2 w-2 shrink-0 rounded-full', colorClass, className)}
      title={`Urgency: ${urgency}`}
      aria-label={`Urgency: ${urgency}`}
    />
  );
}
